import { createAsyncThunk } from '@reduxjs/toolkit';
import { registration } from '../../api/auth/service';


export const registrationThunk = createAsyncThunk('user/registration', async (email: string, thunkAPI) => {
  const response = await registration(email, thunkAPI);
  return response;
});